import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const BankHoliday = types.compose(
  BaseEntity,
  types
    .model('BankHoliday', {
      bankHolidayId: types.identifierNumber,
      code: types.string,
      name: types.string
    })
);
